module.exports = __webpack_public_path__ + "static/media/c12_10.7eda7c1a.png";